import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Button from 'components/Buttons/Button';
import { GumbLogo } from 'static';
import LogoImg from 'static/BGLogo.jpg';

export const AuthContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100svh;
  overflow: hidden scroll;
  background: white;
  width: 100vw;
`;

export const Header = styled.h1`
  position: relative;
  font-size: 28px;
  color: ${(props) => props.theme.color.pickledBluewood};
  font-weight: 700;
  text-align: center;
  margin-bottom: 30px;

  & > svg {
    position: absolute;
    left: -5px;
    top: 5px;
    cursor: pointer;
  }
`;

export const HeaderWithBack = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
`;

export const HeaderTitle = styled.h1`
  font-size: 28px;
  color: ${(props) => props.theme.color.pickledBluewood};
  font-weight: 700;
  text-align: center;
  margin: 0;
  line-height: 1.2;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: ${(props) => props.theme.color.pickledBluewood};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
`;

export const MessageContainer = styled.div`
  font-weight: 400;
  color: ${(props) => props.theme.color.pickledBluewood};
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background-color: #fff0f0;
  text-align: left;
  border-left: 3px solid #e53e3e;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 20px;
  font-size: 13px;
  line-height: 1.5;
  color: #c53030;
  font-weight: 500;
  white-space: pre-line;

  a {
    color: #33aba7;
    -webkit-text-decoration: none;
    text-decoration: none;
    font-weight: 600;
  }

  svg {
    flex: 0 0 auto;
    margin-top: 2px;
  }

  svg * {
    fill: currentColor;
  }
`;

export const FormContainer = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.color.white};
  padding: 40px 20px;
  width: 50%; /* exactly 50% split */

  @media (max-width: 1024px) {
    width: 100%;
    padding: 30px 20px;
  }

  form {
    margin: auto;
    width: 100%;
  }
`;

export const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 50%;
  height: 100%;
  background-image: url(${LogoImg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const StyledGumbLogo = styled(GumbLogo)`
  display: none;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 1024px) {
    display: block;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 25px;
  width: 100%;

  @media (max-width: 350px) {
    max-width: 100%;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
  font-size: 13px;
  font-weight: 500;
`;

export const ForgotPassword = styled(Link)`
  color: ${(props) => props.theme.color.baliHai};
  text-decoration: none;
  font-weight: 500;
`;

export const StyledForm = styled.form`
  max-width: 400px;
  width: 100%;
  margin: 0 auto;

  /* Make SocialContainer's inner div match form width */
  & > div {
    width: 100%;
  }

  @media (max-width: 350px) {
    max-width: 100%;
  }
`;

export const StyledLink = styled.a`
  color: ${(props) => props.theme.color.brightTurquoise};
  text-decoration: none;

  &:visited {
    color: ${(props) => props.theme.brightTurquoise};
  }
`;
